import { useEffect } from 'react';
import { CoreAPI, useIdentity } from '../../../core';
import { getEditorOperateState } from '../../states/editor-operate-state';
import { HOTKEY_TYPE } from '../config';

/** 优先使用系统复制/剪切/粘贴的元素 */
const EXCLUDE_ELEMENT_NAMES = ['INPUT', 'TEXTAREA'];
/** 禁止粘贴的class */
const EXCLUDE_CLASS_NAMES = ['ant-scrolling-effect'];

/** 检查target是否支持复制/剪切/粘贴 */
function checkTargetSystemOperate(e: any, checkClassName = false) {
    const nodeName = EXCLUDE_ELEMENT_NAMES.includes((e?.target as HTMLElement).nodeName);
    const className = EXCLUDE_CLASS_NAMES.includes((e?.target as HTMLElement).className);
    if (checkClassName) {
        return nodeName || className;
    }
    return nodeName;
}

export const SystemEvent = () => {
    const identity = useIdentity();
    const coreApi = CoreAPI(identity);

    function checkIsDisableOperate() {
        const editorOperateState = getEditorOperateState(identity);
        return (
            editorOperateState.disableOperate ||
            editorOperateState.disablePick ||
            coreApi.getShowContextMenu() ||
            editorOperateState.isMouseSelect
        );
    }

    useEffect(() => {
        const copyLayer = (e: ClipboardEvent | null) => {
            if (checkTargetSystemOperate(e)) return;
            if (checkIsDisableOperate()) return;
            coreApi.events.emit(HOTKEY_TYPE.copy, e);
        };
        const pasteLayer = async (e: ClipboardEvent | null) => {
            if (checkTargetSystemOperate(e)) return;
            if (checkIsDisableOperate()) return;
            coreApi.events.emit(HOTKEY_TYPE.paste, e);
        };
        const cutLayer = (e: ClipboardEvent | null) => {
            if (checkTargetSystemOperate(e)) return;
            if (checkIsDisableOperate()) return;
            coreApi.events.emit(HOTKEY_TYPE.cut, e);
        };
        document.addEventListener('paste', pasteLayer);
        document.addEventListener('copy', copyLayer);
        document.addEventListener('cut', cutLayer);
        return () => {
            document.removeEventListener('paste', pasteLayer);
            document.removeEventListener('copy', copyLayer);
            document.removeEventListener('cut', cutLayer);
        };
    }, []);

    return null;
};
